import { extendObservable, action, computed } from 'mobx';
import { Exclude, Expose, classToPlain } from 'class-transformer';

@Exclude()
export default class FeedbackChain {
  constructor(store, id, persisted = true) {
    this.store = store;
    extendObservable(this, {
      @Expose()
      id: id,

      @Expose()
      category: FeedbackChain.categories.FEEDBACK,

      @Expose()
      title: '',

      @Expose()
      description: '',

      createdAt: null,

      updatedAt: null,

      doneAt: null,

      persisted: persisted,

      attachmentFilesQueue: [],

      attachments: [],

      selectedNotifiables: []
    });
  }

  serialize() {
    let basicSerialize = classToPlain(this);
    basicSerialize['notified_members'] = this.selectedNotifiables.map(
      el => el.id
    );
    return basicSerialize;
  }

  toJson() {
    return this.serialize();
  }

  @action
  setTitle(title) {
    this.title = title;
  }

  @action
  setDescription(description) {
    this.description = description;
  }

  @action
  addAttachment(file) {
    this.attachmentFilesQueue.push(file);
    // Save attachments only if the attachable has already been persisted in backend.
    if (this.persisted) {
      this.persistAttachments();
    }
  }

  @action
  removeFileFromQueue(file) {
    this.attachmentFilesQueue.remove(file);
  }

  @action
  persistAttachments() {
    return new Promise(async (resolve, reject) => {
      if (this.persisted) {
        while (this.attachmentFilesQueue.length > 0) {
          const file = this.attachmentFilesQueue.pop();
          await this.store.attachmentsStore.create(file, this);
        }
        resolve();
      } else {
        reject();
        throw 'AttachmentOnInvalidObjectException';
      }
    });
  }

  canEditAttachments() {
    return false;
  }

  @action
  setCategory(category) {
    this.category = category;
  }

  @action
  persist() {
    this.store.createBackend(this);
  }

  @action
  setPersisted(val) {
    this.persisted = val;
  }

  @action
  setId(val) {
    this.id = val;
  }

  @action
  cancelEdition() {
    this.title = '';
    this.description = '';
    this.attachmentFilesQueue = [];
    this.attachments = [];
    this.category = FeedbackChain.categories.FEEDBACK;
  }

  isValid() {
    return this.title.length > 0 && this.description.length >= 10;
  }

  @action
  setSelectedNotifiables(members) {
    this.selectedNotifiables = members;
  }

  get notifiables() {
    const team = this.store.rootStore.team;
    return team.map(teamMember => teamMember.user);
  }
}

FeedbackChain.categories = {
  INTERNAL: 'internal',
  FEEDBACK: 'feedback',
  ISSUES: 'issues',
  SUPPORT: 'support'
};

// Required by the attachments store
FeedbackChain.backendModelName = 'FeedbackChain';
